import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JwtToken } from '../models/token.model';
import { User } from '../models/user.model';
import { API_ENDPOINT, BaseHttpService, ENDPOINTS } from './base-http.service';
import { TokenService } from './token.service';
import jwt_decode from 'jwt-decode';

@Injectable({
    providedIn: 'root',
})
export class UserService extends BaseHttpService {
    private _currentUser: User | null = null;

    constructor(
        private http: HttpClient,
        protected _tokenService: TokenService
    ) {
        super(_tokenService);
        this._tokenService.getToken().subscribe((token: JwtToken) => {
            if (token) {
                try {
                    const decodedToken: any = jwt_decode(token.access);
                    this._currentUser = {
                        email: decodedToken.email,
                        firstName: decodedToken.first_name,
                        lastName: decodedToken.last_name,
                        apiKey: decodedToken.tts_key,
                    } as User;
                } catch (Error) {
                    this._currentUser = null;
                }
            } else {
                this._currentUser = null;
            }
        });
    }

    // TODO: add the returned type to be a specific object
    login(email: string, password: string): Observable<any> {
        return this.http.post(`${API_ENDPOINT}/${ENDPOINTS.TOKEN}/`, {
            email,
            password,
        });
    }

    // TODO: add the returned type to be a specific object
    register(email: string, name: string, password: string): Observable<any> {
        return this.http.post(`${API_ENDPOINT}/${ENDPOINTS.REGISTER}/`, {
            email,
            password,
            name,
        });
    }

    // TODO: add the returned type to be a specific object
    getUserConfig(): Observable<any> {
        return this.http.get(
            `${API_ENDPOINT}/${ENDPOINTS.USER_CONFIG}/`,
            this.authorizedRequestOptions
        );
    }

    // TODO: add the returned type to be a specific object
    saveUserConfig(phonems: string, transliterals: string): Observable<any> {
        return this.http.put(
            `${API_ENDPOINT}/${ENDPOINTS.USER_CONFIG}/`,
            {
                phonems,
                transliterals,
            },
            this.authorizedRequestOptions
        );
    }

    // TODO: add the returned type to be a specific object
    addUserConfig(phonems: string, transliterals: string): Observable<any> {
        return this.http.post(
            `${API_ENDPOINT}/${ENDPOINTS.USER_CONFIG}/`,
            {
                phonems,
                transliterals,
            },
            this.authorizedRequestOptions
        );
    }

    // TODO: add the returned type to be a specific object
    changePass(newPass1: string, newPass2: string): Observable<any> {
        return this.http.put(
            `${API_ENDPOINT}/${ENDPOINTS.CHANGE_PASS}/`,
            {
                password1: newPass1,
                password2: newPass2,
            },
            this.authorizedRequestOptions
        );
    }

    getCurrentUser(): User | null {
        return this._currentUser;
    }

    isAuthenticated() {
        return this._currentUser !== null;
    }
}
